import styled from 'styled-components';

const VersionTag = styled.div`
  z-index: 1;
  position: absolute;
  top: 12px;
  left: 50%;
  transform: translate(-50%, 0%);
`;

export default VersionTag;
